import GeniusEquationGraph from './GeniusEquationGraph';
export default GeniusEquationGraph;
